import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../components/common/InputComp/Input";
import TabComp from "../../../components/TabsComp/TabComp";
import Btn from "../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../utils/asyncStatus";
import { primaryColor } from "../../../utils/themeColors";
import {
  addOMAdminCurrencyAsync,
  deleteOMAdminCurrencyAsync,
  editOMAdminCurrencyAsync,
  getOMAdminCurrencyAsync,
} from "../../../store/services/orderManagementService";
const AdminCurrency = () => {
  const dispatch = useDispatch();
  const {
    getOMAdminCurrencyStatus,
    getOMAdminCurrencyError,
    getOMAdminCurrencyData,
    addOMAdminCurrencyStatus,
    addOMAdminCurrencyData,
    addOMAdminCurrencyError,

    editOMAdminCurrencyStatus,
    editOMAdminCurrencyError,
    editOMAdminCurrencyData,

    deleteOMAdminCurrencyData,
    deleteOMAdminCurrencyStatus,
    deleteOMAdminCurrencyError,
  } = useSelector((state) => state.om);

  useEffect(() => {
    dispatch(getOMAdminCurrencyAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getOMAdminCurrencyData?.length
    ? getOMAdminCurrencyData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedAdminCurrency, setSelectedAdminCurrency] = useState();
  const [addAdminCurrencyMode, setAddAdminCurrencyMode] = useState(false);
  const [addAdminCurrencyData, setAddAdminCurrencyData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedAdminCurrency", selectedAdminCurrency);
  // console.log("editData", editData);
  useEffect(() => {
    if (addOMAdminCurrencyStatus === asyncStatus.SUCCEEDED) {
      setAddAdminCurrencyMode(false);
      setSaveDisabled(true);
      setAddAdminCurrencyData();
    }
  }, [, addOMAdminCurrencyStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteOMAdminCurrencyAsync(selectedAdminCurrency?.currency_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteOMAdminCurrencyStatus === asyncStatus.SUCCEEDED || deleteOMAdminCurrencyStatus === asyncStatus.ERROR ) {
      setOpen(false);
      setSelectedAdminCurrency();
    }
  }, [, deleteOMAdminCurrencyStatus]);
  useEffect(() => {
    if (editOMAdminCurrencyStatus === asyncStatus.SUCCEEDED) {
      setSelectedAdminCurrency();
      setEditMode(false);
      setEditData()
    }
  }, [, editOMAdminCurrencyStatus]);

  //   const [tableHeight, setTableHeight] = useState("");
  //   let elem = document.getElementById("containerHeight");
  //   useEffect(() => {
  //     console.log("elem?.offsetHeight",elem?.clientHeight);
  //     setTableHeight(elem?.offsetHeight);
  //   }, [ elem?.offsetHeight]);
  // console.log(containerHeight)
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this admin currency?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Admin Currency"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Admin Currency
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddAdminCurrencyMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addAdminCurrencyMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addAdminCurrencyMode}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddAdminCurrencyMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addAdminCurrencyMode || !selectedAdminCurrency}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addOMAdminCurrencyStatus === asyncStatus.LOADING ||
                  editOMAdminCurrencyStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addAdminCurrencyData) {
                    dispatch(addOMAdminCurrencyAsync(addAdminCurrencyData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedAdminCurrency, ...editData };
                    delete a.id;
                    dispatch(editOMAdminCurrencyAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={500} width={"100%"}>
              <TableComp
                columns={[
                  { field: "currency_id", headerName: "ID", flex: true },
                  { field: "currency_name", headerName: "Admin Currency", flex: true },
                ]}
                onRowClick={(e) => {
                  setSelectedAdminCurrency(e?.row);
                }}
                rows={formattedData}
                loading={
                  getOMAdminCurrencyStatus === asyncStatus.IDLE ||
                  getOMAdminCurrencyStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addAdminCurrencyMode ? (
              <InputWithBtnLayoutComp
              error={addOMAdminCurrencyError}
                inputArray={[
                  {
                    label: "Admin Currency:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddAdminCurrencyData({
                            ...addAdminCurrencyData,
                            currency_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddAdminCurrencyData({
                            ...addAdminCurrencyData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedAdminCurrency ? (
              <InputWithBtnLayoutComp
              error={editOMAdminCurrencyError}
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedAdminCurrency?.currency_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "AdminCurrency:",
                    comp: (
                      <InputComp
                        key={selectedAdminCurrency?.currency_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            currency_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedAdminCurrency?.currency_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={selectedAdminCurrency?.is_active|| editData?.is_active}
                        disabled={!editMode}
                        // defaultValue={selectedAdminCurrency?.is_active || editData?.is_active}
                        defaultChecked={selectedAdminCurrency?.is_active || editData?.is_active}
                        // checked={selectedAdminCurrency?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (<Stack>
              <Typography>Select any admin currency</Typography>
              <Typography color={"red"} fontSize={12}>{getOMAdminCurrencyError}</Typography>
            </Stack>
            )}
            <Stack my={2}>
              <TabComp
                tabs={[
                  //   {
                  //     name: "Companies",
                  //     content: (
                  //       <Stack height={400} width={"100%"}>
                  //         <TableComp
                  //           columns={[
                  //             {
                  //               field: "companyId",
                  //               headerName: "Company ID",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "companyName",
                  //               headerName: "Company Name",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "action",
                  //               headerName: "Action",
                  //               flex: true,
                  //             },
                  //           ]}
                  //           //   onRowClick={(e) => {
                  //           //     setSelectedAdminCurrency(e?.row);
                  //           //   }}
                  //           rows={[]}
                  //           //   loading={
                  //           //     getProductStyleStatus === asyncStatus.IDLE ||
                  //           //     getProductStyleStatus === asyncStatus.LOADING
                  //           //   }
                  //         />
                  //       </Stack>
                  //     ),
                  //   },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedAdminCurrency(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default AdminCurrency;
